import React from "react";

const OrderDetails = () => {
  return (
    <section className="orderDetails">
      <main>
        <div className="order-hade">
          <div>
            <img src="/ras-malai.png" alt="logo" />
            <h1>Hello,{"hasnine"}</h1>
            <p>Thank you for your order.</p>
          </div>
          <div>
            <h1>Order Details</h1>
            <b>Order Id</b>
            {`#${"sdf54fdfdf"}`}
          </div>
        </div>
        <div className="order-card">
        <div>
          <div>
            <p>BILLING INFORMATION</p>
            <p><b>Name</b>{"Hasnine"}</p>
            <p><b>Mobile</b>{`012458963`}</p>
          </div>
          <div>
            <p>PAYMENT INFORMATION</p>
            <p>
              <b>PAYMENT METHOD</b>
              {"Online"}
            </p>
            <p>
              <b>Payment Id</b>
              {`#${"sdf54fdfdf"}`}
            </p>
            <p>
              <b>Paid At</b>
              {"23-02-23"}
            </p>
          </div>
        </div>
        <div>
          <div>
          <p>SHIPPING INFORMATION</p>
          <p>
            <b>Order Status</b>
            {"Processing"}
          </p>
          <p>
            <b>Place At</b>
            {"23-02-23"}
          </p>
          <p>
            <b>Delivered At</b>
            {"25-02-23"}
          </p>
          </div>
          <div style={{gap:"2px"}}>
          <p>AMOUNT</p>
          <p>
            <b>Items Total</b>৳{500}
          </p>
          <p>
            <b>Shipping Charges</b>৳{50}
          </p>
          <p>
            <b>Tax</b>৳{70}
          </p>
          <p>
            <b>Total Amount</b>৳{500 + 50 + 70}
          </p>
        </div>
        </div>
        </div>
        <article>
          <h1>Order Items</h1>
          <div>
            <h4>Ras malai</h4>
            <div>
              <span>{12}</span> X  <span>{232}</span>
            </div>
          </div>
          <div>
            <h4>Mishti doi</h4>
            <div>
              <span>{12}</span> X  <span>{232}</span>
            </div>
          </div>
          <div>
            <h4>Roshgolla</h4>
            <div>
              <span>{12}</span> X  <span>{232}</span>
            </div>
          </div>
          <div>
            <h4>Sub total</h4>
            <div>
              {"৳23456"}
            </div>
          </div>
        </article>
      </main>
    </section>
  );
};

export default OrderDetails;
